import React, { useContext, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { NCRContext } from 'views';
import { UserContext } from 'components/routing';

import { SubmitButton } from 'components/form/prototypes';

const CreateOrder = () => {

  const { id } = useParams();
  const { state } = useContext(NCRContext);
  const { user } = useContext(UserContext);

  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(_ =>
      ['QA', 'GM'].includes(user.role) &&
      state.ncr.status.id === 3 &&
      state.ncr.order.orderItems.length > 0
    )
  }, [user.role, state.ncr.status.id, state.ncr.order.orderItems]);

  const request = {
    method: 'patch',
    url: `/api/ncr/${id}`,
    data: {
      ...state.ncr,
      status: { id: 4 },
      amended_by: user.id
    }
  };

  return visible && <SubmitButton name='Create Order' request={request} validate toast={{ message: 'Order Created' }} />;
}

export { CreateOrder };
